'use client';
import React from 'react';
import cn from './style.module.scss';

export default function WelcomeLuxury(props: any) {
  const { t } = props;
  return (
    <div className={cn.launchGRDLuxury}>
      <div className={cn.luxuryGRDBlock}>
        <h2>{t['yasLuxuryHeading']}</h2>
        <p>{t['yasLuxuryContent']}</p>
      </div>
    </div>
  );
}
